export const FeatureAssignmentThingTypeMrn = "mrn:sl2:::featureAssignment";
